import { render, staticRenderFns } from "./SharedItemsTab.vue?vue&type=template&id=3c6505fa&scoped=true"
import script from "./SharedItemsTab.vue?vue&type=script&lang=js"
export * from "./SharedItemsTab.vue?vue&type=script&lang=js"
import style0 from "./SharedItemsTab.vue?vue&type=style&index=0&id=3c6505fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6505fa",
  null
  
)

export default component.exports